import React, { useState } from 'react';
import { OPEN_STATUSES, rpcError, stockLabel, possiblyAttended, canDiscard } from './config';
import { L } from './ui';
import LeadCard from './LeadCard';
import AssignControl from './AssignControl';
import DiscardControl from './DiscardControl';

// Leads sin asignar, el más antiguo primero. "Cogerlo" se lo queda quien pulse primero.
export default function Bandeja({ supabase, leads, access, profiles, accessRows, vehicles, columns, afterChange, onOpen }) {
  const [busyId, setBusyId] = useState(null);
  const [errors, setErrors] = useState({});
  const list = leads
    .filter(l => !l.assigned_to && OPEN_STATUSES.includes(l.status))
    .sort((a, b) => new Date(a.received_at) - new Date(b.received_at));

  const claim = async (lead) => {
    setBusyId(lead.id);
    setErrors(e => ({ ...e, [lead.id]: '' }));
    const { error } = await supabase.rpc('claim_lead', { p_lead_id: lead.id });
    setBusyId(null);
    afterChange();
    if (error) { setErrors(e => ({ ...e, [lead.id]: rpcError(error) })); return; }
    onOpen(lead.id);
  };

  if (list.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 12px' }}>
        <div style={{ fontSize: '2rem' }}>📭</div>
        <p style={{ color: 'var(--t-cbd5e1)', margin: '8px 0 4px' }}>No hay leads esperando.</p>
        <p style={L.muted}>Cuando entre uno nuevo aparecerá aquí al momento y te llegará un correo.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: '10px' }}>
      <p style={{ ...L.muted, margin: 0 }}>
        {list.length} lead{list.length === 1 ? '' : 's'} esperando. El primero que pulse <strong>Cogerlo</strong> se lo queda.
      </p>
      {list.map(lead => (
        <div key={lead.id}>
          <LeadCard
            lead={lead}
            mode="bandeja"
            stock={stockLabel(lead, vehicles, columns)}
            onOpen={() => onOpen(lead.id)}
            actions={access.ok && (access.can_claim || access.supervisor || canDiscard(lead, access, null)) ? (
              <>
                {access.can_claim && (
                  <button type="button" style={L.button} disabled={busyId === lead.id} onClick={() => claim(lead)}>
                    {busyId === lead.id ? 'Cogiendo…' : '✋ Cogerlo'}
                  </button>
                )}
                {access.supervisor && (
                  <AssignControl compact supabase={supabase} lead={lead} profiles={profiles} accessRows={accessRows} onDone={afterChange} />
                )}
                {possiblyAttended(lead) && canDiscard(lead, access, null) && (
                  <DiscardControl compact supabase={supabase} lead={lead} onDone={afterChange} />
                )}
              </>
            ) : null}
          />
          {errors[lead.id] && <div style={{ ...L.error, marginTop: '6px' }}>{errors[lead.id]}</div>}
        </div>
      ))}
    </div>
  );
}
